import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'shorten'
})
export class ShortenPipe implements PipeTransform {

  transform(value: string, limit = 15): any {
    if (value && typeof value === 'string') {
      if (value.length <= limit) {
        return value;
      }
      return `${value.substr(0, limit)}...`;
    }
    return value;
  }

}
